// removed by extract-text-webpack-plugin
module.exports = {"loader":"_3pUM_NzDnEm0vp7hfHUnnB","small":"_2KYOEyY71d7ujt_18GiKeA","wheel":"_30U7aYYcqCuqmqfhbP8A4N","medium":"_3wXbj1i98Fyfw5QZvZt6SJ","large":"_2BgFrQVCKDoj6jvA-kQMCn","blue":"_1oXHofr1IygtJKm46GKTZ_","white":"OcR78vqgAIinBcfa9UzDt","wheel-rotate-semi":"Ias7KgM3ZJBUuWhcIbkTi","wheelRotateSemi":"Ias7KgM3ZJBUuWhcIbkTi","wheel-rotate-inner":"T_aPY7FMwYiB5th-bPzIQ","wheelRotateInner":"T_aPY7FMwYiB5th-bPzIQ","text":"_1xYBmzOs76dBTVM42QyACn"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Loader/Loader.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Loader/Loader.scss
// module chunks = 0